<style lang="scss">
@import "../../assets/sass/abstracts/_variables.scss";

nav.top-navigation {
  background: linear-gradient(to top, #dadee1 0%, #ffffff 100%);
  height: 75px;
  -webkit-box-shadow: 0 2px 4px 0 rgba(3, 27, 78, 0.1);
  box-shadow: 0 2px 4px 0 rgba(3, 27, 78, 0.1);
  border-bottom: 1px solid $nodata-border;

  .logo-container {
    padding: 10px;
    span.logo {
      margin: auto;
      margin-top: 7.5px;
      display: block;
      text-align: center;
      font-size: 30px;
      color: $black;
      text-transform: uppercase;
    }
    img {
      height: 50px;
    }
  }
  div.title {
    margin-top: 22px;
    font-size: 22px;
    //text-align: center;
    font-family: "Lucida Sans Unicode", "Lucida Grande", sans-serif;
    font-weight: bold;
    text-transform: uppercase;
    color: $nina-darkgray;
  }

  @media screen and (max-width: 70.000em) {
    div.title {
      display: none;
    }
  }
}
</style>
<template>
  <nav class="top-navigation">
    <div class="grid-x">
      <div class="large-3 medium-4 small-4 cell">
        <div class="logo-container">
          <router-link :to="{ name: 'watercourses'}">
            <img
              src="https://www.nina.no/Portals/NINA/Bilder/logoweb.png?ver=2014-01-13-144007-227"
              height="50"
              class="logo"
              title="Norsk institutt for naturforskning"
            />
          </router-link>
        </div>
      </div>
      <div class="large-9 cell">
        <div class="title">Genetisk påvirkning av rømt oppdrettslaks på ville laksebestander</div>

      </div>
      <div class="large-3 medium-4 small-4 cell">
      </div>
    </div>
   

  </nav>
</template>
<script>
export default {};
</script>
